/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit2_TInputs */

const en_to_typescript_pit2_t = /** @type {(inputs: To_Typescript_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The root interface is called RootObject`)
};

const ko_to_typescript_pit2_t = /** @type {(inputs: To_Typescript_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`루트 인터페이스 이름은 RootObject입니다`)
};

const ja_to_typescript_pit2_t = /** @type {(inputs: To_Typescript_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルートインターフェースの名前は RootObject です`)
};

/**
* | output |
* | --- |
* | "The root interface is called RootObject" |
*
* @param {To_Typescript_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit2_t = /** @type {((inputs?: To_Typescript_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit2_t(inputs)
	if (locale === "ko") return ko_to_typescript_pit2_t(inputs)
	return ja_to_typescript_pit2_t(inputs)
});